import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { handleErrors } from "../../../services/dataManager";
import {
  fetchAdViewsDaily,
  fetchAdViewsHourly,
  fetchAdViewsThreeHourly,
} from "../../../services/axios/apiManager";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import { format } from "date-fns";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function PeakAdViewTimes() {
  const tableRef = useRef(null);
  const navigation = useNavigate();
  const [hourlyData, setHourlyData] = useState([]);
  const [threeHourlyData, setThreeHourlyData] = useState([]);
  const [dailyData, setDailyData] = useState([]);
  const [combinedData, setCombinedData] = useState([
    ...threeHourlyData,
    ...dailyData,
  ]);
  const [selectedTimeFrame, setSelectedTimeFrame] = useState("");

  const getAdViewsThreeHourly = async () => {
    const res = await fetchAdViewsThreeHourly();
    if (res.data?.success && res?.data?.data) {
      setThreeHourlyData(res.data.data);
    } else {
      handleErrors(res, navigation);
    }
  };
  const getAdViewsDaily = async () => {
    const res = await fetchAdViewsDaily();
    if (res.data?.success && res?.data?.data) {
      setDailyData(res.data.data);
    } else {
      handleErrors(res, navigation);
    }
  };

  const getAdViewsHourly = async () => {
    const res = await fetchAdViewsHourly();
    if (res.data?.success && res?.data?.data) {
      setHourlyData(res.data.data);
    } else {
      handleErrors(res, navigation);
    }
  };

  const handleChange = (e) => {
    setSelectedTimeFrame(e.target.value);
    if (e.target.value === "hourly") {
      setCombinedData(hourlyData);
    } else if (e.target.value === "daily") {
      setCombinedData(dailyData);
    } else {
      setCombinedData([...threeHourlyData, ...dailyData]);
    }
  };

  const handleReset = () => {
    setSelectedTimeFrame("");
    setCombinedData([...threeHourlyData, ...dailyData]);
  };

  const hourlyChartData = {
    labels: hourlyData?.map((item) => item.duration),
    datasets: [
      {
        label: "Ad Views",
        data: hourlyData?.map((item) => item.count),
        backgroundColor: "rgba(255, 206, 86, 0.6)",
      },
    ],
  };

  const hourlyChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff",
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff",
        },
      },
    },
  };
  const dailyChartData = {
    labels: dailyData?.map((item) => item.duration),
    datasets: [
      {
        label: "Ad Views",
        data: dailyData?.map((item) => item.count),
        backgroundColor: "rgba(255, 206, 86, 0.6)",
      },
    ],
  };
  const dailyChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff",
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff",
        },
      },
    },
  };
  useEffect(() => {
    getAdViewsDaily();
    getAdViewsHourly();
    getAdViewsThreeHourly();
  }, []);

  // console.log('threeHourlyData :', threeHourlyData);
  
  useEffect(() => {
    // if(threeHourlyData?.length){
    //   // console.log('Formated    :', format("12", 'a'));
    //   let temp = []
    //   for(let item of threeHourlyData){
    //     const splited = item?.duration.split("-")
    //     const lower = `${splited[0]}`

    //   }

    // }
    setCombinedData([...threeHourlyData, ...dailyData]);
  }, [dailyData, threeHourlyData]);
  // // // // // // // // // // // // // Table
  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = combinedData.map((item) => {
      return [item.duration.replace("24", "00"), item.count];
    });

    const config = {
      data: rows,
      columns: [{ title: "Time Frame" }, { title: "Ad Views" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [combinedData]);
  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter Ad View Times</h5>
          <div className="row align-items-center">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedTimeFrame}
                onChange={handleChange}
              >
                <option value="">All time frames</option>
                <option value="hourly">Hourly</option>
                <option value="daily">Daily</option>
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button className="btn btn-success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Peak Ad View Times</h5>
          <p className="card-text">
            Identify when users watch the most ads (hourly/daily trends).
          </p>

          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {combinedData?.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Views by Hours</h6>
          <Bar data={hourlyChartData} options={hourlyChartOptions} />
        </div>
      </div>
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Views by Days</h6>
          <Bar data={dailyChartData} options={dailyChartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default PeakAdViewTimes;
